module.exports = __webpack_public_path__ + "assets/custom-asset-mini-icon.30a82583.svg";